import request from '@/plugin/axios'; //分页查询

export function searchAlarmUsers(params) {
  return request({
    url: '/admin/alarm/user/search',
    method: 'get',
    params: params
  });
}
export function fetchAlarmUsers(params) {
  return request({
    url: '/admin/alarm/user/all',
    method: 'get',
    params: params
  });
}
export function saveAlarmUser(params) {
  return request({
    url: '/admin/alarm/user/save',
    method: 'post',
    params: params
  });
}
export function deleteAlarmUser(params) {
  return request({
    url: '/admin/alarm/user/delete',
    method: 'post',
    params: params
  });
}
export function deleteMultiAlarmUsers(params) {
  return request({
    url: '/admin/alarm/user/deleteMulti',
    method: 'post',
    params: params
  });
}